// src/App.js 
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProfilePage from "./pages/ProfilePage";
import PrivateRoute from "./components/PrivateRoute";
import UsersList from "./pages/UsersList";
import UserCreate from "./pages/UserCreate";
import UserEdit from "./pages/UserEdit";
import UserDetails from "./pages/UserDetails"; 
import RegisterPage from "./pages/RegisterPage";
import SocietesList from "./pages/SocietesList";
import SocieteDetails from "./pages/SocieteDetails";
import NotificationsPage from "./pages/NotificationsPage";
import ActivationPage from "./pages/ActivationPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SocieteEdit from "./pages/SocieteEdit";
import SocieteUsers from "./pages/SocieteUsers";
import ClientList from "./pages/ClientList";
import ClientCreate from "./pages/ClientCreate";
import ClientDetails from "./pages/ClientDetails";
import ClientEdit from "./pages/ClientEdit";
import SiteList from "./pages/SiteList";
import SiteCreate from "./pages/SiteCreate";
import SiteDetails from "./pages/SiteDetails";
import SiteEdit from "./pages/SiteEdit";
import SitesMap from "./pages/SitesMap";
import AffectationsList from "./pages/AffectationsList";
import AffectationsCreate from "./pages/AffectationsCreate";
import AffectationsBySite from "./pages/AffectationsBySite";
import AffectationControleurDetail from "./pages/AffectationControleurDetail";
import AffectationsControleursList from "./pages/AffectationsControleursList";
import AffectationsControleursCreate from "./pages/AffectationsControleursCreate";
import RoundList from "./pages/rondes/RondesList";
import RoundDetail from "./pages/rondes/RondesDetails";
import IncidentList from "./pages/incidents/IncidentList";
import IncidentDetail from "./pages/incidents/IncidentsDetails";
import CreateIncidentType from "./pages/incidents/typeIncidents/CreateTypeIncident";
import TypeIncidentList from "./pages/incidents/typeIncidents/TypeIncidentList";
import EditIncidentType from "./pages/incidents/typeIncidents/EditTypeIncident";
import CreateTag from "./pages/tags/CreateTags";
import TagList from "./pages/tags/ListeTags";
import EditTag from "./pages/tags/EditTags";
import TagDetails from "./pages/tags/DetailsTags";
import MainCouranteDetails from "./pages/MainCouranteDetails";
import MainCouranteList from "./pages/MainCouranteList";
import ProductTypeList from "./pages/type_products/ProductTypeList";
import ProductTypeCreate from "./pages/type_products/ProductTypeCreate";
import UsersImport from "./pages/UsersImport";
import HistoriqueRappels from "./pages/HistoriqueRappels";
import ClientImport from "./pages/ClientImport";

import EntrerStockCreate from "./pages/entrer_stock/EntrerStockCreate"
import SortirStockCreate from "./pages/sortir_stock/SortirStockCreate";
import ProductTypeUpdate from "./pages/type_products/ProductTypeUpdate";

import ProductCreate from "./pages/products/ProductCreate";
import ProductList from "./pages/products/ProductList";
import ProductUpdate from "./pages/products/ProductUpdate";
import ProductDetail  from "./pages/products/ProductDetail";
import TaskList from "./pages/taches/TacheListe";
import TacheCreate from "./pages/taches/TacheCreate";
import TacheDetail from "./pages/taches/TacheDetails";
import TacheEdit from "./pages/taches/TacheUpdate";

import OffresList from "./pages/OffresList";
import OffresCreate from "./pages/OffresCreate";
import OffresDetails from "./pages/OffresDetails";
import OffresEdit from "./pages/OffresEdit";
import AbonnementsCreate from "./pages/AbonnementsCreate";
import AbonnementsList from "./pages/AbonnementsList";
import AbonnementsDetails from "./pages/AbonnementsDetails";
import AbonnementsRenew from "./pages/AbonnementsRenew";
import AbonnementsEdit from "./pages/AbonnementsEdit";
import TutorialAdminList from "./pages/TutorialAdminList";
import TutorialCreate from "./pages/TutorialCreate";
import TutorialDetails from "./pages/TutorialDetails";
import TutorialEdit from "./pages/TutorialEdit";
import TutorialList from "./pages/TutorialList";
import ConfirmEmail from "./pages/ConfirmEmail";
import AchatQuota from "./pages/AchatQuota";
import QuotaList from "./pages/QuotaList";
import PlanningList from "./pages/PlanningList";
import Rapports from "./pages/Rapports";
import RapportClient from "./pages/RapportClient";
import ParametresPaiement from "./pages/ParametresPaiement";
import ParametresQuotas from "./pages/ParametresQuotas";
import DashboardPartenaires from "./pages/DashboardPartenaires";
import HistoriquePaiements from "./pages/HistoriquePaiements";
import Journaux from "./pages/Journaux";
import PosteControle from "./pages/PosteControle";
import Vitrine from "./pages/Vitrine";


function App() {
  return (
    <Router>
      <Routes>
        {/* Page de login publique */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />

        {/* Routes protégées */}
  <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<ProfilePage />} />
          
          {/* Gestion utilisateurs  */}
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/create" element={<UserCreate />} /> 
          <Route path="/users/details/:id" element={<UserDetails />} /> 
          <Route path="/users/:id/edit" element={<UserEdit />} />
          <Route path="/activation" element={<ActivationPage />} />
          <Route path="/users/import" element={<UsersImport />} />
          

          {/* Gestion societes  */}
        <Route path="/societes" element={<SocietesList />} />
      <Route path="/societes/details/:id" element={<SocieteDetails />} />
        <Route path="/societes/edit/:id" element={<SocieteEdit />} />
       {/*<Route path="/societes/create" element={<SocieteCreate />} />  */}
       <Route path="/societes/:id/users" element={<SocieteUsers />} />

       {/* Gestion notification */}
       <Route path="/notifications" element={<NotificationsPage />} />

       {/* Gestion clients */}
        <Route path="/clients" element={<ClientList />} />
        <Route path="/clients/create" element={<ClientCreate />} />
        <Route path="/clients/details/:id" element={<ClientDetails />} />
        <Route path="/clients/edit/:id" element={<ClientEdit />} />
        <Route path="/historique-rappels" element={<HistoriqueRappels />} />
        <Route path="/client-import" element={<ClientImport />} />

            {/* Gestion sites */} 
        <Route path="/sites" element={<SiteList />} />
        <Route path="/sites/create" element={<SiteCreate />} />
        <Route path="/sites/details/:id" element={<SiteDetails />} />
        <Route path="/sites/edit/:id" element={<SiteEdit />} />
        <Route path="/sites/map" element={<SitesMap />} />

             {/* Gestion Affectation d'un agent a un site  */} 
        <Route path="/affectations" element={<AffectationsList />} />
        <Route path="/affectations/create" element={<AffectationsCreate />} />
        <Route path="/affectations/site/:id_site" element={<AffectationsBySite />} />

        <Route
          path="/affectations-controleurs"
          element={<AffectationsControleursList />}
        />
        <Route
          path="/affectations-controleurs/create"
          element={<AffectationsControleursCreate />}
        />
        <Route
          path="/affectations-controleurs/detail/:id"
          element={<AffectationControleurDetail />}
        />
<Route path="/maincourante" element={<MainCouranteList />} />
       <Route path="/maincourante/details/:id" element={<MainCouranteDetails />} />
      
                        {/* gestion rondes */} 
                <Route path="/rondes" element={<RoundList />} />
                <Route path="/rondes/:id" element={<RoundDetail />} />
  {/* gestion incident*/} 
                <Route path="/incidents" element={<IncidentList />} />
                 <Route path="/incidents/:id" element={<IncidentDetail />} />
                 <Route path="/typeIncidents" element={<TypeIncidentList />} />
<Route path="/create" element={<CreateIncidentType />} />
<Route path="/typeIncidents/edit/:id" element={<EditIncidentType />} />

{/*gestion types produits */}
            <Route path="/product-types" element={<ProductTypeList />} />
            <Route path="/product-types/new" element={<ProductTypeCreate />} />
            <Route path="/product-types/:id/update" element={<ProductTypeUpdate />} />
            {/* gestion entrer stock */}
            <Route path="/entrer-stock" element={<EntrerStockCreate />} />
            {/* gestion sortir stock */}
            <Route path="/sortir-stock" element={<SortirStockCreate />} />
            {/* gestion produits */}
            <Route path="/products" element={<ProductList />} />
            <Route path="/products/new" element={<ProductCreate />} />
            <Route path="/products/:id/update" element={<ProductUpdate />} />
            <Route path="/products/:id/detail" element={<ProductDetail />} />

  {/* gestion des tags*/} 

  <Route path="/tags/creer" element={<CreateTag />} />
    <Route path="/tags" element={<TagList/>} />
<Route path="/tags/modifier/:id" element={<EditTag />} />
        <Route path="/tags/:id" element={<TagDetails />} />

        {/* gestion des taches*/} 

  <Route path="/taches" element={< TaskList/>} />
  <Route path="/taches/create" element={<TacheCreate />} />
    <Route path="/taches/:id" element={<TacheDetail />} />
<Route path="/taches/edit/:id" element={<TacheEdit />} />


{/* Gestion offre abonnement   */}
      <Route path="/offres" element={<OffresList />} />
      <Route path="/offres/create" element={<OffresCreate />} />
      <Route path="/offres/details/:id" element={<OffresDetails />} />
      <Route path="/offres/edit/:id" element={<OffresEdit />} />

        {/* Gestion  abonnement   */}
      <Route path="/abonnements/create" element={<AbonnementsCreate />} />
      <Route path="/abonnements" element={<AbonnementsList />} />
      <Route path="/abonnements/details/:id" element={<AbonnementsDetails />} />
      <Route path="/abonnements/renew/:id" element={<AbonnementsRenew />} />
      <Route path="/abonnements/edit/:id" element={<AbonnementsEdit />} />

{/* Gestion  tuto   */}
<Route path="/tutos/admin" element={<TutorialAdminList />} />
<Route path="/tutos/create" element={<TutorialCreate />} />
<Route path="/tutos/details/:id" element={<TutorialDetails />} />
<Route path="/tutos/edit/:id" element={<TutorialEdit />} />
<Route path="/tutos" element={<TutorialList />} />

<Route path="/achat-quota" element={<AchatQuota />} />
<Route path="/quotas/list" element={<QuotaList />} />
<Route path="/planning" element={<PlanningList />} />
<Route path="/rapports" element={<Rapports />} />
<Route path="/rapports/client" element={<RapportClient />} />
<Route path="/parametres-paiement" element={<ParametresPaiement />} />
<Route path="/parametres-quotas" element={<ParametresQuotas />} />
<Route path="/retraits-partenaires" element={<DashboardPartenaires />} />
<Route path="/historique-paiements" element={<HistoriquePaiements />} />
<Route path="/journaux" element={<Journaux />} />
<Route path="/poste-controle" element={<PosteControle />} />

        </Route>

        {/* Site vitrine : point d'entrée public (redirige vers /dashboard si déjà connecté) */}
        <Route path="/" element={<Vitrine />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;